import useDisplayNames from '../useDisplayNames'
import pluralize from 'pluralize'

const useEvidenceDisplayName = () => {
    const { getDisplayName } = useDisplayNames()
    const plural = getDisplayName('evidence', 'Evidence')
    const singular = pluralize.singular(plural)

    return { singular, plural }
}

export default useEvidenceDisplayName
